import React, { Component } from 'react';
import swal from 'sweetalert';
import ReactPaginate from 'react-paginate';
import SDIConstants from '../SDIConstants';
import * as $ from 'jquery';
import * as CookieService from '../CookieService';
import * as WALNonCatalogAction from '../actions/WALNonCatalogAction';
import WALNonCatalogStore from '../stores/WALNonCatalogStore';
import * as NonCatalogAction from '../actions/NonCatalogAction';
import NonCatalogStore from '../stores/NonCatalogStore';
import WOPartsComponent from '../components/WOPartsComponent';
import HomepageStore from '../stores/HomepageStore';
import * as HomepageAction from '../actions/HomepageAction';
import { withTranslation, Trans } from 'react-i18next';
import * as ShoppingCartAction from '../actions/ShoppingCartAction';
import ShoppingCartStore from '../stores/ShoppingCartStore';
import Select from 'react-select';
import * as MenuAction from '../actions/MenuAction';
let isWOBtnClick = false;
let rmvAttachindex = -1;
let preferedShipto;


class WALNonCatalogComponent extends Component {
    constructor(props) {
        super(props);
        this.loadCartItem = this.loadCartItem.bind(this);
        this.ClearWO = this.ClearWO.bind(this);
        this.handleWorkOrderSearch = this.handleWorkOrderSearch.bind(this);
        this.AnykeyPress = this.AnykeyPress.bind(this);
        this.handleWOhistory = this.handleWOhistory.bind(this);
        this.workOrderSearchResponse = this.workOrderSearchResponse.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeQuantity = this.handleChangeQuantity.bind(this);
        const queryparam = new URLSearchParams(window.location.search)
        this.ClearWO = this.ClearWO.bind(this);
        this.submitOrder = this.submitOrder.bind(this);
        const orgin = queryparam.get('Orgin')

        this.state = {
            mfgPartNumber: "",
            mfgName: "",
            recommendedSupplier: "",
            supplierPrtNbr: "",
            description: "",
            quantity1: "",
            uom: "",
            attachmentPathArr: [], attachmentPathCartArr: [],
            removeattach: [],
            AddAttachPUp: false,
            OLPriority: false,
            notes: "",
            OLWorkOrderTB: "",
            CusNotes: "",
            cartItem: [],
            ShipToDDValue: [],
            uomDDValue: [],
            Login_UserId: (CookieService.getLocalStorageValues("Session_AGENTUSERID") == "" ? CookieService.getLocalStorageValues("Session_UserID") : CookieService.getLocalStorageValues("Session_AGENTUSERID")),
            Login_UserBU: (CookieService.getLocalStorageValues("Session_AGENTUSERBU") == "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU")),
            ItemId: "", UniqId: "", RemovePopupId: false,
            WONum: localStorage.getItem("WONum") == null || localStorage.getItem("WONum") == undefined ? '' : localStorage.getItem("WONum"),
            isValidWO: localStorage.getItem("WONum") == null || localStorage.getItem("WONum") == undefined ? false : true,
            WO_Parts: localStorage.getItem("WO_Parts") != null && localStorage.getItem("WO_Parts") != undefined && localStorage.getItem("WO_Parts") != "" ? JSON.parse(localStorage.getItem("WO_Parts")) : [],
            defaultShipto: "",
            ShiptoDD: [],
            locWOParts: [],
            ImagePathArr: [],
            AllShipTo: [],
            locCountryMatch: true,
            StatusMsg: '',
            StatusMsg1: '',
            StatusMsg2: '',
            attachError: ''

        }

    }

    componentDidMount() {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let IsThirdParty = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != "0" && CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null ? true : false;
        let WO_Type = CookieService.getLocalStorageValues("WO_Type") != "" && CookieService.getLocalStorageValues("WO_Type") != null ? CookieService.getLocalStorageValues("WO_Type") : "";

        if (WO_Type.toUpperCase() != 'WALMART' && IsThirdParty != false) {
            this.props.history.push({
                pathname: "/HomePage",
            });
        }

        else {
            this.loadCartItem()
            NonCatalogStore.on('attachmentResponse', this.attachmentResponse);
            NonCatalogStore.on('rmvAttach', this.removeAttachmentResponse);
            WALNonCatalogStore.on('SubmitOrderResponse', this.submitOrderResoponse);
            WALNonCatalogStore.on('WalmartNonCatalog_Page_Load', this.cartItemResponse);
            WALNonCatalogStore.on('WalmartNonCatalog_removecartItem', this.removeItemResponse);
            WALNonCatalogStore.on('SaveNonCatalogEntry', this.saveBtnClickResponse);
            WALNonCatalogStore.on('WalmartNonCatalog_UpdateLineLevelItem', this.UpdateLineLevelItemResponse);
            WALNonCatalogStore.on('workordercheckresponsewal', this.workOrderSearchResponse);
            WALNonCatalogStore.on('WOfailwal', this.workorderfail);
            ShoppingCartStore.on('attachmentResponse', this.loadAttachments);
        }

    }

    componentWillUnmount() {
        NonCatalogStore.removeListener('attachmentResponse', this.attachmentResponse);
        NonCatalogStore.removeListener('rmvAttach', this.removeAttachmentResponse);
        WALNonCatalogStore.removeListener('SubmitOrderResponse', this.submitOrderResoponse);
        WALNonCatalogStore.removeListener('WalmartNonCatalog_Page_Load', this.cartItemResponse);
        WALNonCatalogStore.removeListener('WalmartNonCatalog_removecartItem', this.removeItemResponse);
        WALNonCatalogStore.removeListener('SaveNonCatalogEntry', this.saveBtnClickResponse);
        WALNonCatalogStore.removeListener('WalmartNonCatalog_UpdateLineLevelItem', this.UpdateLineLevelItemResponse);
        WALNonCatalogStore.removeListener('workordercheckresponsewal', this.workOrderSearchResponse);
        WALNonCatalogStore.removeListener('WOfailwal', this.workorderfail);
        ShoppingCartStore.removeListener('attachmentResponse', this.loadAttachments);
    }
    loadCartItem = () => {
        let GetCartBO = {
            userID: CookieService.getLocalStorageValues("Session_UserID"),
            userBU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_USERTYPE: CookieService.getLocalStorageValues("Session_USERTYPE"), //WW-1163

        }
        WALNonCatalogAction.GetCartItem(GetCartBO)
    }

    loadAttachments = () => {
        //
        const { t } = this.props
        //document.getElementById("AttachError").innerText = ""
        let tempAttachments = ""
        let isValid = ShoppingCartStore.attachmentResponse.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
        $("#WalcartcustomFile").val('');
        if (isValid) {
            let attachmentResponse = JSON.parse(ShoppingCartStore.attachmentResponse);
            //BUG 2421 CANNOT ABLE TO ADD MUTIPLE FILES  Pavithra R
            tempAttachments = this.state.attachmentPathCartArr;
            if (tempAttachments != null) {
                tempAttachments = tempAttachments.concat(attachmentResponse);
            }
            else {
                tempAttachments = attachmentResponse;
            }
            this.setState({ attachmentPathCartArr: tempAttachments, attachmentErrormsg: "" })
        } else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t("You have exceeded the length of total file names.\nPlease adjust your entry or remove longer file names")
            });
            // alert("You have exceeded the length of total file names.\nPlease adjust your entry or remove longer file names");
            
            this.setState({
                attachmentErrormsg: "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names.",
                attachError: "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
            });
        }
        // this.setState({ attachmentPathArr: tempAttachments })

    };

    cartItemResponse = () => {
        const {t} = this.props
        let Response = JSON.parse(WALNonCatalogStore.pageLoad);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let CartItem = Response.CartItems
        let UOM = Response.UOM
        let ShipToDD = Response.ShipToDD
        let defaultshiptotemp = []
        //WW-1163 to check if the user has privilege to access non-catalog request -Vishwa S
        let HashTable = Response.Hashtable;
        let NoncatalogPrilg = HashTable.filter((item, index) => item.Key == "NONCAT" || item.Key == "HT-NONCAT");
        if (NoncatalogPrilg.length == 0) {
            //$(`#${SDIConstants.SDILoader}`).addClass('hide');
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t("Insufficient privilege to view non-catalog request")
            });
            this.props.history.push({
                pathname: "/HomePage",
            });
        }

        let ShiptoValue = []
        let PerferedShipto = {
            value: "0",
            label: "--Select Ship To--"
        }
        let isStoreValue = true;
        let locCountryMatch = true;

        let uomDefaultValue = UOM.filter((item) => item.UNIT_OF_MEASURE == "EA").length > 0 ? "EA" : "";
        let StoreValue = JSON.parse(localStorage.getItem("StoreValue"))
        let Defaultship = CookieService.getLocalStorageValues("Session_ISAShipToID")
        let DefShipTo = Response.ShipToDD.filter((item, index) => item.CUSTID.toUpperCase() == Defaultship.toUpperCase());
        let countryCode = CookieService.getLocalStorageValues("LOCATION") == undefined || CookieService.getLocalStorageValues("LOCATION") == null || CookieService.getLocalStorageValues("LOCATION") == "" || CookieService.getLocalStorageValues("LOCATION") == " " ? "0" : CookieService.getLocalStorageValues("LOCATION");
        if (DefShipTo.length > 0) {
            if (countryCode.toUpperCase() == DefShipTo[0].COUNTRY.toUpperCase()) {
                let locDefShipTo = {
                    value: DefShipTo[0].CUSTID,
                    label: DefShipTo[0].LOCNAME
                }
                PerferedShipto = locDefShipTo;
            }
            else {
                locCountryMatch = false;
            }
        }
        //WW-1020 - User is able to select #1822 Ship To (PR) for #1519 Work Order (USA)
        let LocShiptValue = [];
        if (localStorage.getItem("WONum") != null) {
            let CountryCode = CookieService.getLocalStorageValues("LOCATION");
            if (CountryCode.toUpperCase() == "PRI") {
                LocShiptValue = Response.ShipToDD.filter((item, index) => item.COUNTRY.toUpperCase() == "PRI");
            }
            else {
                LocShiptValue = Response.ShipToDD.filter((item, index) => item.COUNTRY.toUpperCase() == CountryCode.toUpperCase());
            }
        }
        else {
            LocShiptValue = Response.ShipToDD;
        }
        if (LocShiptValue != null && LocShiptValue != undefined) {
            if (LocShiptValue.length > 0) {
                LocShiptValue.map((val, index) => {
                    if (index == 0) {
                        let defaultvalue = {
                            value: "0",
                            label: "--Select Ship To--"
                        }
                        ShiptoValue.push(defaultvalue)
                    }
                    let localArray = {
                        value: val.CUSTID,
                        label: val.LOCNAME
                    }
                    //if (val.CUSTID == Defaultship) {
                    //    PerferedShipto = localArray
                    //    isStoreValue = false
                    //}
                    //else if (val.CUSTID == StoreValue && isStoreValue == true) {
                    //    PerferedShipto = localArray
                    //}

                    ShiptoValue.push(localArray)
                })
            }
        }
        let WO = localStorage.getItem("WONum")

        this.setState({ cartItem: CartItem, uomDDValue: UOM, uom: uomDefaultValue, ShipToDDValue: ShiptoValue, defaultShipto: PerferedShipto.value === "W09301" || PerferedShipto.value === "W02409" ? { value :"0", label: "-- Select Ship To --" } : PerferedShipto, AllShipTo: Response.ShipToDD, isCountryMatch: locCountryMatch })
        if (WO != undefined && WO != null && WO.trim() != "") {
            $("#work-order").addClass("disabledbutton");

        }
    }

    removeItemResponse = () => {
        const { t} = this.props
        let deleteItem = JSON.parse(WALNonCatalogStore.deleteItem);
        let status = deleteItem.deleteStatusTable

        if (!this.state.RemovePopupId) {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            if (status[0].deleteStatus == "True") {
                localStorage.removeItem('WONum')
                localStorage.removeItem('WOAssetID')
                localStorage.removeItem('StoreValue')
                localStorage.removeItem('WOAssetTag')
                localStorage.removeItem('WO_Parts')
                CookieService.updateLocalStorageValues("AssetTag", "");
                CookieService.updateLocalStorageValues("AssetID", "");
                CookieService.updateLocalStorageValues("Trade", "");
                CookieService.updateLocalStorageValues("Category", "");
                CookieService.updateLocalStorageValues("Make", "");
                CookieService.updateLocalStorageValues("Model", "");
                CookieService.updateLocalStorageValues("WO_Make", "");
                CookieService.updateLocalStorageValues("WO_Model", "");
                CookieService.updateLocalStorageValues("WO_Address", "");
                $("#work-order").removeClass("disabledbutton");
                $('#cancelPopupId').modal('hide');
                this.props.history.push({
                    pathname: "/HomePage",
                });
                //[WW-1325-Cart Count Updation, Vishwa S]
                //MenuAction.refreshCartCount();
                return false
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t("Technical Issue -- Contact SDI")
                });
                return false
            }
        }
        let cart;
        if (status[0].deleteStatus == "True") {
            cart = deleteItem.CartItems
            this.setState({ cartItem: cart, RemovePopupId: false })
            //[WW-1325-Cart Count Updation, Vishwa S]
            //MenuAction.refreshCartCount();
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t("Technical Issue -- Contact SDI")
            });
            this.setState({ cartItem: cart, RemovePopupId: false })

        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

    }

    AnykeyPress = (e) => {
        if (e.keyCode == 13) {
            this.handleWorkOrderSearch(true)
        }
    }


    handleWOhistory = (event, WOhistory) => {
        if (WOhistory == true) {
            $('#WO_Parts_Popup').modal('show');
        }
        else {
            $('#WO_Parts_Popup').modal('hide');
        }
    }

    saveBtnClickResponse = () => {
        const { t } = this.props
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let saveResponse = JSON.parse(WALNonCatalogStore.saveNonCatalogEntry);
        let status = saveResponse.FlagTable
        let cart = saveResponse.CartItems

        if (status[0].isSuccess == "True" || status[0].isSuccess == null) {
            this.clearBtnClick();
            this.setState({ cartItem: cart })
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t("Successfully added to  cart")
            })
            //[WW-1325-Cart Count Updation, Vishwa S]
            //MenuAction.refreshCartCount();
            let WO = localStorage.getItem("WONum")

            if (WO != undefined && WO != null && WO.trim() != "") {
                $("#work-order").addClass("disabledbutton");
            }
            this.setState({ WONum: localStorage.getItem("WONum") });

        }
    }


    UpdateLineLevelItemResponse = () => {
        const { t } = this.props
        let update = JSON.parse(WALNonCatalogStore.deleteItem);
        let status = update.UpdateStatus
        if (status[0].Status == "True") {
            let cart = update.CartItems
            this.setState({ cartItem: cart })
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t("Technical Issue -- Contact SDI")
            });
            this.setState({ RemovePopupId: false })
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

    }

    handleChangeShipto = (values) => {
        let ShipToSelected = []
        if (values.label != undefined && values.label != null) {
            ShipToSelected = values
            //document.getElementById('StatusMsg2').innerText = "";
            //document.getElementById('StatusMsg1').innerText = "";
            this.setState(
                { defaultShipto: ShipToSelected, StatusMsg2: "", StatusMsg1: "" });
        }

    }

    handleAttachment = (event) => {
        const {t} = this.props
        let files = event.target.files;
        let filetype = files[0].type;
        if (!(filetype.toLowerCase().includes('jpg') || (filetype.toLowerCase().includes('png')) || (filetype.toLowerCase().includes('jpeg')) || (filetype.toLowerCase().includes('pdf')))) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t("You can choose only the Image and PDF files!!")
            });
            return;
        }
        console.log("event", files);
        if (files.length > 0) {
            this.setState({ attachmentErrormsg: "" });
            if (this.state.attachmentPathArr.length > 0) {
                for (let i = 0; i < files.length; i++) {
                    let isDuplicate = this.state.attachmentPathArr.filter((attach) => attach.FileName == files[i].name).length > 0 ? true : false;
                    if (isDuplicate) {
                        this.setState({ attachmentErrormsg: "Selected file is already attached, please try again" });
                        return false;
                    }
                }
            }
            //this.setState({ attachmentErrormsg: " " });
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            NonCatalogAction.addAttachment(files);
        }

    }

    attachmentResponse = () => {
        
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        $(`#nAttachments`).val('');
        let isValid = NonCatalogStore.attachmentResponse.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
        if (isValid) {
            let attachmentResponse = JSON.parse(NonCatalogStore.attachmentResponse);
            let tempAttachments = this.state.attachmentPathArr;
            tempAttachments = tempAttachments.concat(attachmentResponse);
            this.setState({ attachmentPathArr: tempAttachments });
            console.log("tempAttachments", tempAttachments);
        } else {
            this.setState({
                attachmentErrormsg: "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
            });
        }
    };

    downloadAttachment = (e, attachment) => {
        e.preventDefault();
        let downloadBO = {
            fileName: attachment.FileName,
            filePath: attachment.FilePath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        NonCatalogAction.downloadAttachment(downloadBO);
    };

    removeAttachments = (filepath, index) => {
        console.log(filepath);
        rmvAttachindex = index
        let removeBO = {
            filePath: filepath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        NonCatalogAction.removeAttachment(removeBO);
    }

    removeAttachmentResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let isValid = NonCatalogStore.removeAttachmentResponse.indexOf("success") >= 0 ? true : false;
        if (isValid) {
            let tempAttachments = this.state.attachmentPathArr;
            tempAttachments.splice(rmvAttachindex, 1);
            let errorMsgAttach = "";
            if (tempAttachments.length > 0) {
                let attachmentStr = tempAttachments.map(e => e.FilePath).join("|");
                if (attachmentStr.length > 254) {
                    errorMsgAttach = "You have exceeded the length of total file names.\nPlease adjust your entry or remove longer file names."
                }

            }
            this.setState({ attachmentPathArr: tempAttachments, attachmentErrormsg: errorMsgAttach });
            rmvAttachindex = -1;
        }
    };


    submitOrder = () => {
        const { t } = this.props
        let OLShipTo = "";
        if (this.handleWorkOrderSearch(false)) {
            if (parseInt(this.state.quantity) == 0 || this.state.quantity == "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please enter a valid Quantity"
                });
                return false
            }
            if (this.state.defaultShipto != undefined && this.state.defaultShipto != null && this.state.defaultShipto != "" && this.state.defaultShipto.value != 0) {
                OLShipTo = this.state.defaultShipto.value;
            }
            else {
                this.setState({ StatusMsg1: "Please select Ship to ", StatusMsg2: "Please select Ship to " })
                return false
            }

            let PlaceOrderBo = {
                Session_ID: CookieService.getLocalStorageValues("Session_ID"),
                SOURCE: "WEB",
                Session_UserID: this.state.Login_UserId,
                Session_BUSUNIT: this.state.Login_UserBU,
                Session_SITEBU: CookieService.getLocalStorageValues("Session_SITEBU"),
                punchinSessionID: "",
                Session_USERTYPE: CookieService.getLocalStorageValues("Session_USERTYPE"),
                Session_EMAIL: CookieService.getLocalStorageValues("Session_EMAIL"),
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),
                Session_TestMode: CookieService.getLocalStorageValues("Session_TESTMODE"),
                Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
                CurrentPage_Url: "/SDIXZEUS/WalmartRFQEntry",
                Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
                Session_MobIssuing: CookieService.getLocalStorageValues("Session_MobIssuing"),
                Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                Session_CARTFAIL: CookieService.getLocalStorageValues("Session_CARTFAIL"),
                Session_ValidateWorkOrder: CookieService.getLocalStorageValues("Session_ValidateWorkOrder"),
                Validation_Status: "True",
                chkLineNumFlag: "",
                Session_CUSTID: CookieService.getLocalStorageValues("Session_CUSTID"),
                Order_WorkOrder: CookieService.getLocalStorageValues("Session_CARTWOREQ") == 'N' && this.state.WONum == "" ? " " : this.state.WONum,
                Order_OrderNO: "",
                Order_MachineNum: "",
                Order_Customer_Notes: this.state.notes,
                Order_ShipTo: (OLShipTo == '0' || OLShipTo == '' || OLShipTo == undefined) ? CookieService.getLocalStorageValues("homestoreloc") : OLShipTo,
                Order_PriorityOrder: $('#olpriority').is(":checked") ? "True" : "False",
                Order_Type: "",
                Location2: "",
                USER_CHAR2: "",
                ISA_USER2: "",
                USER_CHAR1: "",
                IsWeb: true,
                Trade: CookieService.getLocalStorageValues("Trade"),
                Order_WOCategory: CookieService.getLocalStorageValues("WO_CAT_DESC") == "" || CookieService.getLocalStorageValues("WO_CAT_DESC") == undefined || CookieService.getLocalStorageValues("WO_CAT_DESC") == null ? "" : CookieService.getLocalStorageValues("WO_CAT_DESC"),
                WO_Type: CookieService.getLocalStorageValues("WO_Type") == "" || CookieService.getLocalStorageValues("WO_Type") == undefined || CookieService.getLocalStorageValues("WO_Type") == null ? 'WALMART' : CookieService.getLocalStorageValues("WO_Type")
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            WALNonCatalogAction.submitOrderBtnClick(PlaceOrderBo)
        }
    }

    submitOrderResoponse = () => {
        const { t } = this.props
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let submitResponse = WALNonCatalogStore.submitresponse;
        if (submitResponse.includes("successfully")) {
            $('#submitResponsePopupId').modal('show');
            this.setState({ WONum: "" });
            localStorage.removeItem('WONum')
            localStorage.removeItem('WOAssetID')
            localStorage.removeItem('StoreValue')
            localStorage.removeItem('WOAssetTag')
            localStorage.removeItem('WO_Parts')
            CookieService.updateLocalStorageValues("AssetTag", "");
            CookieService.updateLocalStorageValues("AssetID", "");
            CookieService.updateLocalStorageValues("Trade", "");
            CookieService.updateLocalStorageValues("Category", "");
            CookieService.updateLocalStorageValues("Make", "");
            CookieService.updateLocalStorageValues("Model", "");
            CookieService.updateLocalStorageValues("WO_Make", "");
            CookieService.updateLocalStorageValues("WO_Model", "");
            CookieService.updateLocalStorageValues("WO_Address", "");
            //[WW-1325-Cart Count Updation, Vishwa S]
            //MenuAction.refreshCartCount();
            $("#work-order").removeClass("disabledbutton");
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t("Technical Issue -- Contact SDI")
            });
        }
    }

    submitResponseOk = () => {
        $('#submitResponsePopupId').modal('hide');
        //Precart SIT-1 Bugs -Yuvarani K
        CookieService.updateLocalStorageValues("Shipment_Method", false)
        this.props.history.push({
            pathname: "/HomePage",
        });
    }

    cancelOrder = () => {
        $('#cancelPopupId').modal('show');
    }

    cancelOrderConfirm = () => {
        let cancelorderBo = {
            userID: this.state.Login_UserId,
            userBU: this.state.Login_UserBU,
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
            Interactive: false
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        WALNonCatalogAction.DeleteCartItem(cancelorderBo);
    }
    handleQuantity = (LineNo, event) => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let id = "Quantity" + LineNo;
        let tar = 0;
        let Qty = 1;

        tar = $('#' + id).val()
        if (event.currentTarget.value == "+") {
            tar = parseInt(tar) + parseInt(Qty);
        } else if (event.currentTarget.value == "-") {
            tar = parseInt(tar) - parseInt(Qty);
        }
    }
    bindAttachments = () => {
        let atatchmentdata = this.state.attachmentPathArr
        if (atatchmentdata != null && atatchmentdata != undefined) {
            if (atatchmentdata.length > 0) {
                return this.state.attachmentPathArr.map((attachment, index) => {
                    return (
                        <span className="custom-path-preview py-2 px-3 mr-2 mb-2 text-nowrap">
                            {/*<span className="font-12 font-regular mr-2" >{attachment.FileName}</span>*/}
                            <a href="#" className="font-12 font-regular mr-2" style={{ color: 'black' }} onClick={(e) => this.downloadAttachment(e, attachment)}>{attachment.FileName.length > 30 ? attachment.FileName.substring(0, 30) + `...` : attachment.FileName}</a>
                            <span>
                                <img className="cursor-pointer" src="images/file-close-icon.svg" alt="close-icon" onClick={() => this.removeAttachments(attachment.FilePath, index)} />
                            </span>
                        </span>
                    );
                });
            }
        }
    };

    handleWorkOrderSearch = (isWOBtnClick) => {
        const { t } = this.props
        let errorMsg = '';
        let errorMsg1 = '';
        let errorMsg2 = '';
        if (this.state.isValidWO) {
            if (!isWOBtnClick) {
                return true
            }
        }
        else {
            if (CookieService.getLocalStorageValues("Session_CARTWOREQ") != 'N') {
                if (this.state.WONum != undefined && this.state.WONum != null) {
                    if (this.state.WONum.trim() != "") {
                        if (CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") != 'N') {
                            let THIRDPARTY_COMP_ID = ""
                            if (CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null) {
                                THIRDPARTY_COMP_ID = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID")
                            }
                            let WorkOrderBO = {
                                workOrder: this.state.WONum,
                                Session_THIRDPARTY_COMP_ID: THIRDPARTY_COMP_ID,
                                User_Type: CookieService.getLocalStorageValues("Session_SDIEMP"),
                                is_WO_Parts_Needed: true
                            }
                            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                            WALNonCatalogAction.WorkOrderCheck(WorkOrderBO)

                            if (isWOBtnClick == false) {
                                this.setState({ submitbtn: true });
                            }
                            else {
                                this.setState({ submitbtn: false });
                            }
                            return false
                        }
                        else {
							$("#work-order").addClass("disabledbutton");
                            this.setState({ 
								isValidWO: true,
								StatusMsg: errorMsg,
								StatusMsg1: errorMsg1,
								StatusMsg2: errorMsg2
							});
                            return true
                        }
                        
                    }
                    else {
                        if (isWOBtnClick) {
                            errorMsg = "Enter work order number"
                        } else {
                            errorMsg1 = "Enter work order number"
							errorMsg2 = "Enter work order number"
                        
                        }
						this.setState({
							StatusMsg: errorMsg,
							StatusMsg1: errorMsg1,
							StatusMsg2: errorMsg2
						});
						return false
                    }
                }
                else {
                    if (isWOBtnClick) {
                        errorMsg = "Enter work order number"
                    } else {
                        errorMsg1 = "Enter work order number"
                        errorMsg2 = "Enter work order number"
                    }
					this.setState({
                        StatusMsg: errorMsg,
                        StatusMsg1: errorMsg1,
                        StatusMsg2: errorMsg2
                    });
                    return false
                }
            }
            else {
                if (this.state.WONum && this.state.WONum.trim() != "") {
                    if (CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") != 'N') {
                        let THIRDPARTY_COMP_ID = ""
                        if (CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null) {
                            THIRDPARTY_COMP_ID = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID")
                        }
                        let WorkOrderBO = {
                            workOrder: this.state.WONum,
                            Session_THIRDPARTY_COMP_ID: THIRDPARTY_COMP_ID,
                            User_Type: CookieService.getLocalStorageValues("Session_SDIEMP"),
                            is_WO_Parts_Needed: true
                        }
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                        WALNonCatalogAction.WorkOrderCheck(WorkOrderBO)

                        if (isWOBtnClick == false) {
                            this.setState({ submitbtn: true });
                        }
                        else {
                            this.setState({ submitbtn: false });
                        }
                        return false
                    }
                    else {
                        $("#work-order").addClass("disabledbutton");
                        this.setState({ 
								isValidWO: true,
								StatusMsg: errorMsg,
								StatusMsg1: errorMsg1,
								StatusMsg2: errorMsg2
						});
                        return true
                    }

                }
                else {
                    this.setState({ 
							isValidWO: true,
							StatusMsg: errorMsg,
							StatusMsg1: errorMsg1,
							StatusMsg2: errorMsg2
					});
                    return true
                }
            }
        }
    }

    workOrderSearchResponse = () => {
        const { t } = this.props
        localStorage.setItem('WONum', this.state.WONum);
        let loacalloc = ""
        let localWON = ""
        let BilltoStoreLocationLat = ""
        let BilltoStoreLocationLong = ""
        let statusMsg = '';
        let statusMsg1 = '';
        let statusMsg2 = '';
        let Workorderresponse = JSON.parse(WALNonCatalogStore.workorderresponse);
        if (Workorderresponse.WOResponse.length > 0) {
            if (Workorderresponse.WOResponse[0].AssetID != "" && Workorderresponse.WOResponse[0].AssetID != null && Workorderresponse.WOResponse[0].AssetID != undefined && Workorderresponse.WOResponse[0].AssetID != " ") {
                localStorage.setItem('WOAssetID', Workorderresponse.WOResponse[0].AssetID);
                localStorage.setItem('WOAssetTag', Workorderresponse.WOResponse[0].AssetTag);
                if (Workorderresponse.WOResponse[0].WO_Make != "" && Workorderresponse.WOResponse[0].WO_Make != null && Workorderresponse.WOResponse[0].WO_Make != undefined && Workorderresponse.WOResponse[0].WO_Make != " ") {
                    CookieService.updateLocalStorageValues("WO_Make", Workorderresponse.WOResponse[0].WO_Make);
                } if (Workorderresponse.WOResponse[0].WO_Model != "" && Workorderresponse.WOResponse[0].WO_Model != null && Workorderresponse.WOResponse[0].WO_Model != undefined && Workorderresponse.WOResponse[0].WO_Model != " ") {
                    CookieService.updateLocalStorageValues("WO_Model", Workorderresponse.WOResponse[0].WO_Model);
                }
            }
            if (Workorderresponse.WOResponse[0].LOCATION != "" && Workorderresponse.WOResponse[0].LOCATION != null && Workorderresponse.WOResponse[0].LOCATION != undefined && Workorderresponse.WOResponse[0].LOCATION != " ") {
                loacalloc = Workorderresponse.WOResponse[0].LOCATION
                localStorage.setItem("StoreValue", JSON.stringify(loacalloc));
                BilltoStoreLocationLat = Workorderresponse.WOResponse[0].LATITUDE;
                BilltoStoreLocationLong = Workorderresponse.WOResponse[0].LONGITUDE;
                localStorage.setItem("BilltoStoreLocationLat", BilltoStoreLocationLat);
                localStorage.setItem("BilltoStoreLocationLong", BilltoStoreLocationLong);
                console.log("loacalloc", loacalloc);
            }
            if (Workorderresponse.WOResponse[0].Notes != "" && Workorderresponse.WOResponse[0].Notes != null && Workorderresponse.WOResponse[0].Notes != undefined && Workorderresponse.WOResponse[0].Notes != " ") {
                localWON = Workorderresponse.WOResponse[0].Notes;
                //$("#AssetID").attr("disabled", true);
                console.log("Notes", Workorderresponse.WOResponse[0].Notes);

            }
            CookieService.updateLocalStorageValues("Trade", Workorderresponse.WOResponse[0].Trade);
            let homestoreloc = CookieService.getLocalStorageValues("LOCATION");
            CookieService.updateLocalStorageValues("homestoreloc", homestoreloc);
            CookieService.updateLocalStorageValues("LOCATION", Workorderresponse.WOResponse[0].COUNTRY);
            localStorage.setItem("Country", Workorderresponse.WOResponse[0].COUNTRY);
            CookieService.updateLocalStorageValues("WO_Category", Workorderresponse.WOResponse[0].Category);
            CookieService.updateLocalStorageValues("WO_Priority", Workorderresponse.WOResponse[0].Priority);
            CookieService.updateLocalStorageValues("NTEAmount", Workorderresponse.WOResponse[0].NTE);
            CookieService.updateLocalStorageValues("WO_CAT_DESC", Workorderresponse.WOResponse[0].WO_CAT_DESC);
            CookieService.updateLocalStorageValues("WO_Type", Workorderresponse.WOResponse[0].WO_Type);
            CookieService.updateLocalStorageValues("Session_WO_STATE", Workorderresponse.WOResponse[0].STATE); //WW-1231 WO State Restriction -Vishwa S
            CookieService.updateLocalStorageValues("IsBlanketWO", Workorderresponse.WOResponse[0].IsBlanketWO);

            //WW-1374 Update the WO logo, Problem code long and short description to cookie - Nandhini L 
            CookieService.updateLocalStorageValues("Logo", Workorderresponse.WOResponse[0].Logo);
            CookieService.updateLocalStorageValues("ProblemCodeDescription", Workorderresponse.WOResponse[0].ProblemCodeDescription);
            CookieService.updateLocalStorageValues("Description", Workorderresponse.WOResponse[0].Description);


        }
        statusMsg = "";
        statusMsg1 = "";
        statusMsg2 = "";
        let IsThirdParty = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != "0" && CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null ? true : false;
        let WO_Type = CookieService.getLocalStorageValues("WO_Type")

        if (WO_Type.toLowerCase() != 'walmart' && IsThirdParty != false) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t("Please use different work order # for this panel.")
            });
            $(`#${SDIConstants.SDILoader}`).addClass('hide');

            this.setState({ isValidWO: false, WONum: "" })
        }
        else {

            if (this.state.submitbtn == false) {

                if (Workorderresponse.WOParts != undefined && Workorderresponse.WOParts != null) {

                    if (Workorderresponse.WOParts.length > 0) {

                        localStorage.setItem("WO_Parts", JSON.stringify(Workorderresponse.WOParts))
                        this.state.locWOParts = Workorderresponse.WOParts
                        $('#WO_Parts_Popup').modal('show');

                    }
                }
            }
            $("#work-order").addClass("disabledbutton");
            preferedShipto = Workorderresponse.WOResponse[0].LOCATION;
            let test2 = CookieService.getLocalStorageValues("Session_ISAShipToID");

            if (test2 != null && test2 != "" && test2 != undefined && test2 != " ") {

                let defaultshiptotemp = this.state.ShipToDDValue.filter((item, index) => item.value == test2);
                this.state.defaultShipto = defaultshiptotemp[0]
            }
            else {
                let defaultshiptotemp = this.state.ShipToDDValue.filter((item, index) => item.value == preferedShipto);
                this.state.defaultShipto = defaultshiptotemp[0]
            }
            //WW-1020 - User is able to select #1822 Ship To (PR) for #1519 Work Order (USA) - Deepthi
            let ShiptoOptions = [];
            let CountryCode = CookieService.getLocalStorageValues("LOCATION");
            if (CountryCode.toUpperCase() == "PRI") {
                ShiptoOptions = this.state.AllShipTo.filter((item, index) => item.COUNTRY.toUpperCase() == "PRI");
            }
            else {
                ShiptoOptions = this.state.AllShipTo.filter((item, index) => item.COUNTRY.toUpperCase() == CountryCode.toUpperCase());
            }
            let PerferedShipto = "";
            let locCountryMatch = true;
            let localloc = CookieService.getLocalStorageValues("Session_ISAShipToID") == null || CookieService.getLocalStorageValues("Session_ISAShipToID") == "" ? "0" : CookieService.getLocalStorageValues("Session_ISAShipToID");
            let DefShipTo = this.state.AllShipTo.filter((item, index) => item.CUSTID.toUpperCase() == localloc.toUpperCase());
            if (DefShipTo.length > 0) {
                if (CountryCode.toUpperCase() == DefShipTo[0].COUNTRY.toUpperCase()) {
                    let locDefShipTo = {
                        value: DefShipTo[0].CUSTID,
                        label: DefShipTo[0].LOCNAME
                    }
                    PerferedShipto = locDefShipTo;
                }
                else {
                    locCountryMatch = false;
                }
            }
            let ShiptoDD = [];
            if (ShiptoOptions != null && ShiptoOptions != undefined) {
                if (ShiptoOptions.length > 0) {
                    ShiptoOptions.map((val, index) => {
                        if (index == 0) {
                            let defaultvalue = {
                                value: "0",
                                label: "--Select Ship To--"
                            }
                            ShiptoDD.push(defaultvalue)
                        }
                        let localArray = {
                            value: val.CUSTID,
                            label: val.LOCNAME
                        }
                        ShiptoDD.push(localArray)

                    });
                }
            }
            if (PerferedShipto === CookieService.getLocalStorageValues("IsBlanketWO")) {
                PerferedShipto = {
                    value: "0",
                    label: "--Select Ship To--"
                };
            }
            this.setState({ isValidWO: true, WO_Parts: this.state.locWOParts, ShipToDDValue: ShiptoDD, defaultShipto: PerferedShipto, isCountryMatch: locCountryMatch, StatusMsg: statusMsg, StatusMsg1: statusMsg1, StatusMsg2:statusMsg2 });

            if (this.state.submitbtn) {
                this.submitOrder()
            }
            else {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
            }
        }

    }

    workorderfail = () => {
       
        let errorMsg = '';
        let errorMsg1 = '';
        let errorMsg2 = '';
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        if (this.state.submitbtn == true) {

            errorMsg = "Enter Valid Work Order #";
            errorMsg1 = "Enter Valid Work Order #";
            errorMsg2 = "";
            this.setState({ submitbtn: false, isValidWO: false, WONum: "" })
        } else {

            this.setState({ submitbtn: false, isValidWO: false, WONum: "" });

            errorMsg = "Enter Valid Work Order #";
            errorMsg1 = "";
            errorMsg2 = "";

        }
        this.setState({
            StatusMsg: errorMsg,
            StatusMsg1: errorMsg1,
            StatusMsg2: errorMsg2
        });
    }

    ClearWO = () => {
        const {t}=this.props
        localStorage.removeItem('WONum')
        localStorage.removeItem('WOAssetID')
        localStorage.removeItem('StoreValue')
        localStorage.removeItem('WOAssetTag')
        localStorage.removeItem('WO_Parts')
        CookieService.updateLocalStorageValues("AssetTag", "");
        CookieService.updateLocalStorageValues("AssetID", "");
        CookieService.updateLocalStorageValues("Trade", "");
        CookieService.updateLocalStorageValues("Category", "");
        CookieService.updateLocalStorageValues("Make", "");
        CookieService.updateLocalStorageValues("Model", "");
        CookieService.updateLocalStorageValues("WO_Make", "");
        CookieService.updateLocalStorageValues("WO_Model", "");
        CookieService.updateLocalStorageValues("WO_Address", "");
        CookieService.updateLocalStorageValues("Session_WO_STATE", ""); //WW-1231 WO State Restriction -Vishwa S
        $("#work-order").removeClass("disabledbutton");

        let PerferedShipto = [];
        if (CookieService.getLocalStorageValues("Session_ISAShipToID") != null && CookieService.getLocalStorageValues("Session_ISAShipToID") != "" && CookieService.getLocalStorageValues("Session_ISAShipToID") != undefined && CookieService.getLocalStorageValues("Session_ISAShipToID") != " " && this.state.BilltoStore != undefined) {
            let defaultship = this.state.AllShipTo.filter((item, index) => item.CUSTID == CookieService.getLocalStorageValues("Session_ISAShipToID"));
            defaultship.map((val, index) => {
                let localArray = {
                    value: val.CUSTID,
                    label: val.LOCNAME,
                }
                PerferedShipto.push(localArray)
                PerferedShipto = PerferedShipto[0]
            });
        }
        if (PerferedShipto.length != 0) {
            this.setState({ defaultShipto: PerferedShipto.value === "W09301" || PerferedShipto.value === "W02409" ? { value: "0", label: "-- Select Ship To --" } : PerferedShipto })
        }
        else {
            let PerferedShipto = {
                value: "0",
                label: "--Select Ship To--"
            }
            this.setState({ defaultShipto: PerferedShipto })
        }

        this.setState({ WONum: "", isValidWO: "", defaultShipto: "", StatusMsg: "", StatusMsg1: "", StatusMsg2: "", isCountryMatch: true, WO_Parts: [] });
    }


    bindCart = () => {
        
        return this.state.cartItem.map((val, index) => {
            return (
                <>
                    <div className="col-md-12 mb-3">
                        <div className="row mx-0 py-3 item-box">
                            <div className="col-md-12 mb-3">
                                <div className="d-grid d-lg-flex justify-content-between align-items-center">
                                    <div>
                                        <h5 className="font-16 font-bold mb-2 item-id-color">{val.INV_ITEM_ID}</h5>
                                    </div>
                                    <div>
                                        <div className="d-block">
                                            <div className="d-flex justify-content-start justify-content-lg-end">
                                                <label className=" mt-2 catalog-label font-14 label-color mb-0 mr-2"><Trans>Qty </Trans><span>:</span></label>
                                                <div class="quantity buttons_added" style={{ "marginLeft": "1%", "width": "30%", "float": "left", "marginRight": "15%" }} >
                                                    <input type="button" value="-" class="minus" disabled={val.QUANTITY == 1} style={{ "backgroundColor": "white" }} onClick={(e) => this.updateLineItem(val.ISA_UNIQ_NBR, val.INV_ITEM_ID, e, "Quantity")} />
                                                    <input type="number" class="minus" name="quantity" name="Quantityvalue" value={val.QUANTITY} id={'Quantity' + index} title="Qty" readonly size="4" pattern="" inputmode="" style={{ "width": "73%", "borderLeft": "0", "caret-color": "transparent" }} />
                                                    <input type="button" value="+" class="plus" disabled={val.QUANTITY == 99999} style={{ "backgroundColor": "white" }} onClick={(e) => this.updateLineItem(val.ISA_UNIQ_NBR, val.INV_ITEM_ID, e, "Quantity")} />
                                                </div>
                                                {/* <input type="text" value={val.QUANTITY} className="form-control  item-qty-box ml-2" />*/}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 mb-2">
                                <span className="font-12 font-regular label-value-color">{val.DESCR254}</span>
                            </div>
                            <div className="col-md-4 mb-2">
                                <span className="font-12 font-medium label-color mr-2"><Trans>Manufacturer part # </Trans>:</span>
                                <span className="font-12 font-regular label-value-color">{val.CLIENT_MFG_PART}</span>
                            </div>
                            <div className="col-md-4 mb-2">
                                <span className="font-12 font-medium label-color mr-2"><Trans>Manufacturer name</Trans>:</span>
                                <span className="font-12 font-regular label-value-color">{val.MANUFACTURER}</span>
                            </div>
                            <div className="col-md-4 mb-2">
                                <span className="font-12 font-medium label-color mr-2"><Trans>Recommended supplier</Trans>:</span>
                                <span className="font-12 font-regular label-value-color">{val.ISA_USER_DEFINED_2 == "" || val.ISA_USER_DEFINED_2 == null || val.ISA_USER_DEFINED_2 == " " ? "-" : val.ISA_USER_DEFINED_2}</span>
                            </div>
                            <div className="col-md-4 mb-2">
                                <span className="font-12 font-medium label-color mr-2"><Trans>Supplier part #</Trans>:</span>
                                <span className="font-12 font-regular label-value-color">{val.SUPPLIER_PART_NUM == "" || val.SUPPLIER_PART_NUM == null || val.SUPPLIER_PART_NUM == " " ? "-" : val.SUPPLIER_PART_NUM}</span>
                            </div>
                            <div className="col-md-4 mb-2">
                                <span className="font-12 font-medium label-color mr-2">UOM :</span>
                                <span className="font-12 font-regular label-value-color">{val.UNIT_OF_MEASURE}</span>
                            </div>
                            <div className="col-md-4 mb-2">
                                <div className="form-check form-check-inline">
                                    <label className="form-check-label label-color font-12 font-medium font-regular mr-2" htmlFor="priority"><Trans>Is this priority?</Trans></label>
                                    <input className="form-check-input" type="checkbox" id="Walpriority" checked={val.PRIORITY == 'R' ? true : false} onClick={(e) => this.updateLineItem(val.ISA_UNIQ_NBR, val.INV_ITEM_ID, e, "LLPriroty")} defaultValue="option1" />
                                </div>
                            </div>
                            <div className="col-md-12 d-flex align-items-center mb-3">
                                <span className="font-12 font-medium label-color mr-2"><Trans>Attachment </Trans>:</span>
                                <span>
                                    <span className="browse-btn">
                                        <button type="button" className="font-medium font-14 btn btn-primary custom-btn-primary primary-btn" onClick={() => this.LinelevelAtthEdit(val.INV_ITEM_ID, val.ISA_UNIQ_NBR)}><Trans>Browse</Trans></button>
                                        {/** <input type="file" name="myfile" />**/}
                                    </span>
                                </span>
                            </div>
                            <div className="col-md-12">
                                <a href="#" className="remove-order color-validation font-medium font-12 text-decoration-none" onClick={(e) => this.removeItem(e, val.INV_ITEM_ID, val.ISA_UNIQ_NBR)}><img src="Images/remove-order.svg" className="removeorder-icon mr-2 mb-1" alt="Remove Order" /><Trans>Remove</Trans></a>
                            </div>
                        </div>
                    </div>
                </>)
        })
    }
    //Attachment
    LinelevelAtthEdit = (ItemId, UniqID) => {
        let { cartItem } = this.state
        let index = cartItem.findIndex(x => x.INV_ITEM_ID == ItemId && x.ISA_UNIQ_NBR == UniqID);
        let attachmentPathArrLocal = []
        if (cartItem[index].FILE_PATH != null && cartItem[index].FILE_PATH != undefined && cartItem[index].FILE_PATH != " ") {
            if (cartItem[index].FILE_PATH.length > 0) {
                attachmentPathArrLocal = cartItem[index].FILE_PATH.split("|")
            }
            else {

                attachmentPathArrLocal.push(cartItem[index].FILE_PATH)
            }
        }
        let FilePathArray = []
        if (attachmentPathArrLocal != null && attachmentPathArrLocal != undefined) {
            //if (attachmentPathArrLocal.trim() != "") {
            if (attachmentPathArrLocal.length > 0) {
                attachmentPathArrLocal.map((attachment, index) => {
                    let url = attachment;
                    let filename = url.substring(21);
                    let localArray = {
                        FileName: filename,
                        FilePath: url
                    }
                    FilePathArray.push(localArray)
                });
                // }
            }

        }
        this.setState({ ItemId: ItemId, UniqId: UniqID, AddAttachPUp: true, attachmentPathCartArr: FilePathArray });
        $('#addattachment').modal('show');
    }

    clearAttaValid = () => {
        $("#WalcartcustomFile").val('');
        this.setState({ AttachError:""})
    }

    onInputClick = (event) => {
        event.target.value = ''
    }
    //Remove Item form cart
    removeItem = (e, ItemId, Uniqid) => {
        e.preventDefault();
        this.setState({ ItemId: ItemId, UniqId: Uniqid });
        $(`#removePopup`).modal('show');
    }
    removeConfirm = () => {
        let errorMsg = '';
        let errorMsg1 = '';
        let errorMsg2 = '';
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        $(`#removePopup`).modal('hide');
        let { cartItem } = this.state;
        let { ItemId } = this.state;
        let { UniqId } = this.state;
        let index = cartItem.findIndex(x => x.INV_ITEM_ID == ItemId && x.ISA_UNIQ_NBR == UniqId);
        let DeleteItemID = this.state.ItemId;
        let DeleteUniqId = this.state.UniqId;
        let DeleteItemBO = {
            userID: this.state.Login_UserId,
            userBU: this.state.Login_UserBU,
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
            ItemID: DeleteItemID,
            LineNum: DeleteUniqId,
            DeleteFlag: true
        };

     

        WALNonCatalogAction.DeleteCartItem(DeleteItemBO);
        this.setState({RemovePopupId: true, StatusMsg: errorMsg,StatusMsg1: errorMsg1,StatusMsg2: errorMsg2 });

    }
    handleSaveBtnClick = (event) => {
        const {t } = this.props
        if (!this.state.mfgPartNumber.trim() || !this.state.mfgName.trim() || !this.state.quantity1.trim() || !this.state.description.trim()) {

            this.setState({ isInvalid: true });
            return false
        }

        if (parseInt(this.state.quantity1) == 0 || this.state.quantity1 == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t("Please enter a valid Quantity")
            });
            return false
        }

        let attachmentStr = "";
        if (this.state.attachmentPathArr.length > 0) {
            attachmentStr = this.state.attachmentPathArr.map(e => e.FilePath).join("|");
            if (attachmentStr.length > 254) {
                this.setState({
                    attachmentErrormsg: "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
                });
                return false;
            }
        }

        let savenonCatalogBO = {
            txtSupplier: this.state.recommendedSupplier.trim(),
            txtSuppPartNum: this.state.supplierPrtNbr.trim(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_PUNCHIN: "",
            txtEstPrice: "",
            txtDesc: this.state.description.trim(),
            txtMfgPartNum: this.state.mfgPartNumber.trim(),
            txtMfgName: this.state.mfgName.trim(),
            txtQty: this.state.quantity1,
            DropUOM: this.state.uom,
            rblcatalogVisible: false,
            Session_CARTTAXEXMPTFLAG: "",
            filePath: attachmentStr,
            Session_ID: CookieService.getLocalStorageValues("Session_ID"),

        };
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        this.setState({ isInvalid: false });
        WALNonCatalogAction.SaveNonCatalogEntry(savenonCatalogBO);
    }

    handleChangeQuantity = (event) => {
        const re = SDIConstants.quantityRegEX;
        if (event.target.value === '' || re.test(event.target.value)) {
            this.setState({ quantity1: event.target.value });
        }
    }

    //noncatalog detial on change
    handleChange = (event) => {
        //5756 - Work order should be a numeric data and maxof length 9 [4/25/2025] Nachiappan 
        if (event.target.name === "WONum") {
            const onlyNumbers = SDIConstants.quantityRegEX;
            if (event.target.value === '' || onlyNumbers.test(event.target.value)) {
                this.setState({ [event.target.name]: event.target.value, isValidWO: "" });            }
        }
        else {

            this.setState({ [event.target.name]: event.target.value });
        }
    }
    //binding UOM dropdown
    bindUOMDropdown = () => {
        return this.state.uomDDValue.map((uom, index) => {
            return (<option key={index} value={uom.UNIT_OF_MEASURE}>{uom.DESCR}</option>)
        });
    };
    clearBtnClick = () => {
        $(`#nonCatalogSaveSuccess`).hide();
        let uomDefaultValue = this.state.uomDDValue.filter((item) => item.UNIT_OF_MEASURE == "EA").length > 0 ? "EA" : "";
        this.setState({
            mfgPartNumber: "",
            mfgName: "",
            recommendedSupplier: "",
            supplierPrtNbr: "",
            description: "",
            quantity1: "",
            uom: uomDefaultValue,
            attachmentPathArr: [],
            attachmentErrormsg: "",
            isInvalid: false,
        })
    }
    removeCartAttachments = (filepath, index) => {
        const { t } = this.props
        let errorMessage = "";
        let tempAttachments = this.state.attachmentPathCartArr;
        let RemoveAtt = tempAttachments[index]
        let removeattachL = []
        removeattachL.push(RemoveAtt)
        tempAttachments.splice(index, 1);
        this.setState({ attachmentPathCartArr: tempAttachments, removeattach: removeattachL });
        let filepathlength = ""
        for (let i = 0; i < tempAttachments.length; i++) {
            filepathlength = filepathlength + tempAttachments[0].FilePath + "|"
        }
        let lengthvalidate = filepathlength.length > 254 ? 1 : 0
        if (lengthvalidate == 1) {
             errorMessage = "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
        }
        else {
            errorMessage = ""
        }
    }
    handleCartAttachment = (event) => {
        const { t } = this.props
        let errorMsg = "";
        let files = event.target.files;
        let filetype = files[0].type;
        if (!(filetype.toLowerCase().includes('jpg') || (filetype.toLowerCase().includes('png')) || (filetype.toLowerCase().includes('jpeg')) || (filetype.toLowerCase().includes('pdf')))) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t("You can choose only the Image and PDF files!!")
            });
            return;
        }
        let Attachments = this.state.attachmentPathCartArr
        let filesvalue = []
        let removevalue = this.state.removeattach
        if (files.length > 0) {
            if (this.state.attachmentPathCartArr != null && this.state.attachmentPathCartArr != undefined) {
                if (this.state.attachmentPathCartArr.length > 0) {
                    for (let i = 0; i < files.length; i++) {
                        let isDuplicate = this.state.attachmentPathCartArr.filter((attach) => attach.FileName == files[i].name).length > 0 ? true : false;
                        if (isDuplicate) {
                            errorMsg= "Selected file is already attached, please try again"
                            //this.setState({ attachmentErrormsg: "Selected file is already attached, please try again" });
                            return false;
                        }
                        if (removevalue != null && removevalue != undefined) {
                            if (removevalue.length > 0) {
                                this.state.removeattach.map((val, index) => {
                                    if (val.FileName == files[i].name) {
                                        Attachments.push(val)
                                        removevalue.splice(index, 1);
                                    }
                                    else {
                                        filesvalue.push(files[i])
                                    }
                                });
                            }
                            else {
                                filesvalue.push(files[i])
                            }
                        }
                        else {
                            filesvalue.push(files[i])
                        }
                    }
                }
                else {
                    for (let i = 0; i < files.length; i++) {
                        if (removevalue != null && removevalue != undefined) {
                            if (removevalue.length > 0) {
                                this.state.removeattach.map((val, index) => {
                                    if (val.FileName == files[i].name) {
                                        Attachments.push(val)
                                        removevalue.splice(index, 1);
                                    }
                                    else {
                                        filesvalue.push(files[i])
                                    }
                                });
                            }
                            else {
                                filesvalue.push(files[i])
                            }
                        }
                        else {
                            filesvalue.push(files[i])
                        }
                    }
                }
                let filepathlength = ""
                if (Attachments != null && Attachments != undefined) {
                    for (let i = 0; i < Attachments.length; i++) {
                        filepathlength = filepathlength + Attachments[i].FilePath + "|"
                    }
                }
                if (filesvalue != null && filesvalue != undefined) {
                    for (let j = 0; j < filesvalue.length; j++) {
                        //Concatinated the dummy additional temp path in order to match the string length before storing in the temp location
                        filepathlength = filepathlength + "C:\\temp\\000000_000000" + filesvalue[j].name + "|"
                    }
                }
                let Vlauelength = filepathlength.length
                let lengthvalidate = filepathlength.length > 254 ? 1 : 0
                if (lengthvalidate == 1) {
                    errorMsg = "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
                    this.setState({ attachError: errorMsg })
                    return
                }
                else {
                    errorMsg = ""
                    this.setState({ attachError: errorMsg })
                }
                if (lengthvalidate != 1) {
                    if (filesvalue != null && filesvalue != undefined) {
                        if (filesvalue.length > 0) {
                            ShoppingCartAction.addAttachment(filesvalue);
                        }
                    }
                    this.setState({ attachmentPathCartArr: Attachments, removeattach: removevalue })
                }
                $("#WalcartcustomFile").val('');
            }
        }
    };
    bindCartAttachments = () => {
        console.log("attachmentPathCartArr", this.state.attachmentPathCartArr)
        let atatchmentdata = this.state.attachmentPathCartArr
        if (atatchmentdata != null && atatchmentdata != undefined) {
            if (atatchmentdata.length > 0) {
                return this.state.attachmentPathCartArr.map((attachment, index) => {
                    return (
                        <div className="attachment-file-name mt-2 col-md-4 p-0" key={index}>
                            <a href="#" className="noncat-Attachment-overflow" onClick={(e) => this.downloadAttachment(e, attachment)} data-toggle="tooltip" title={attachment.FileName}>{attachment.FileName}</a>
                            <span className="attachment-remove-icon ml-1" onClick={() => this.removeCartAttachments(attachment.FilePath, index)}>X  </span>
                        </div>
                    );
                });
            }
        }
    };
    updateLineItem = (LineNo, ItemIDE, event, field) => {
        let LineNoCount = LineNo;
        let filetoupdate;
        let Attachmentfilevalidation = true
        let targetval;
        let { cartItem } = this.state;
        const { t } = this.props
        let attachErrorMsg = "";
        if (this.state.AddAttachPUp == true) {
            attachErrorMsg = "";
        }
        switch (field) {
            case "LLPriroty": {
                filetoupdate = "Priority"
                let id = "checkPrio" + LineNo;
                let index = cartItem.findIndex(x => x.INV_ITEM_ID == ItemIDE && x.ISA_UNIQ_NBR == LineNo);
                let ExistValue = cartItem[index].PRIORITY;
                targetval = ExistValue != "R" ? "R" : "";
                LineNoCount = cartItem[index].ISA_UNIQ_NBR
                break;
            }
            case "Quantity": {
                let id = "Quantity" + LineNo;
                let tar = 0;
                let index = cartItem.findIndex(x => x.INV_ITEM_ID == ItemIDE && x.ISA_UNIQ_NBR == LineNo);
                let Qty = 1;
                tar = $('#' + id).val()
                if (event.currentTarget.value == "+") {
                    tar = parseInt(cartItem[index].QUANTITY) + parseInt(Qty);
                } else if (event.currentTarget.value == "-") {
                    tar = parseInt(cartItem[index].QUANTITY) - parseInt(Qty);
                }
                targetval = tar;
                LineNoCount = cartItem[index].ISA_UNIQ_NBR;
                filetoupdate = "QUANTITY";
                break;
            }
            case "Attachment": {
                ItemIDE = this.state.ItemId;
                LineNo = this.state.UniqId;
                let index = cartItem.findIndex(x => x.INV_ITEM_ID == ItemIDE && x.ISA_UNIQ_NBR == LineNo);
                LineNoCount = LineNo
                let attachmentStr = "";
                filetoupdate = "FILE_PATH"
                if (this.state.attachmentPathCartArr != null && this.state.attachmentPathCartArr != undefined) {
                    if (this.state.attachmentPathCartArr.length > 0) {
                        attachmentStr = this.state.attachmentPathCartArr.map(e => e.FilePath).join("|");
                        if (attachmentStr.length > 254) {
                            Attachmentfilevalidation = false
                            attachErrorMsg = "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
                            //swal({
                            //    allowOutsideClick: false,
                            //    closeOnClickOutside: false,
                            //    text: "You have exceeded the length of total file names.\nPlease adjust your entry or remove longer file names."
                            //});
                        }
                        else {
                            targetval = attachmentStr
                        }
                    }
                    else {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: t("No file is selected")
                        });
                    }
                }
                else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: t("No file is selected")
                    });
                }
            }

        }
        this.setState({ attachError: attachErrorMsg });
        if (filetoupdate != "" && Attachmentfilevalidation == true) {
            let UpdateItemDetails = {
                userID: this.state.Login_UserId,
                userBU: this.state.Login_UserBU,
                Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
                fldToUpdate: filetoupdate,
                ItemID: ItemIDE,
                LineNum: LineNoCount,
                newValue: targetval
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            WALNonCatalogAction.UpdateItemDesp(UpdateItemDetails);
        }
    }
    render() {
        const { t } = this.props
        return (<React.Fragment>
            <div className="container-fluid container-margin content-section" style={{ marginTop: "140px" }} >
                {/*Page Heading starts here*/}
                <div className="row">
                    <div className="col-md-12 mt-3 page-heading">
                        <h5 className="page-title"><Trans>Non-Catalog Request</Trans></h5>
                    </div>
                </div>
                {/*Page Heading ends here*/}
                <div className="row justify-content-center">
                    <div className="col-md-11 mt-4 pl-0">
                        {/*forms starts here*/}
                        <div className="row">
                            <div className="col-md-4 mb-3">
                                <label className="form-label catalog-label" htmlFor="manufacturer-part"><Trans>Manufacturer part # </Trans><span className="color-manditory">*</span></label>
                                <input type="text" className="form-control rounded" placeholder={t("Enter manufacturer part #")} maxLength="50" value={this.state.mfgPartNumber} name="mfgPartNumber" onChange={this.handleChange} />
                                {this.state.isInvalid && this.state.mfgPartNumber.trim() == "" ? <span className="font-12 font-regular color-validation"><Trans>Please enter manufacturer part #</Trans></span> : null}
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label catalog-label" htmlFor="manufacturer-name"><Trans>Manufacturer name</Trans><span className="color-manditory">*</span></label>
                                <input type="text" className="form-control rounded" placeholder={t("Enter manufacturer name")} id="manufacturer-name" maxLength="30" value={this.state.mfgName} name="mfgName" onChange={this.handleChange} />
                                {this.state.isInvalid && this.state.mfgName.trim() == "" ? <span className="font-12 font-regular color-validation"><Trans>Please enter manufacturer name</Trans></span> : null}
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label catalog-label" htmlFor="supplier"><Trans>Recommended supplier</Trans></label>
                                <input type="text" className="form-control rounded" placeholder={t("Enter recommended supplier")} id="supplier" maxLength="30" value={this.state.recommendedSupplier} name="recommendedSupplier" onChange={this.handleChange} />
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label catalog-label" htmlFor="supplier-part"><Trans>Supplier part #</Trans></label>
                                <input type="text" className="form-control rounded" placeholder={t("Enter supplier part #")} id="supplier-part" maxLength="50" value={this.state.supplierPrtNbr} name="supplierPrtNbr" onChange={this.handleChange} />
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label catalog-label" htmlFor="quantity"><Trans>Quantity</Trans><span className="color-manditory">*</span></label>
                                <input type="text" className="form-control rounded" placeholder={t("Enter quantity")} id="quantity" value={this.state.quantity1} maxLength="5" name="quantity1" onChange={this.handleChangeQuantity} />
                                {this.state.isInvalid && this.state.quantity1.trim() == "" ? <span className="font-12 font-regular color-validation"><Trans>Please enter quantity</Trans></span> : null}
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label catalog-label" htmlFor="uom"><Trans>Unit of measure</Trans></label>
                                <select className="form-control" id="uom" name="uom" value={this.state.uom} onChange={this.handleChange}>
                                    {this.bindUOMDropdown()}
                                </select>
                            </div>
                            <div className="col-md-12 mb-2">
                                <label className="form-label catalog-label w-100"><Trans>Attachment </Trans></label>
                                <div className="row w-100 m-0">
                                    <span className="browse-btn mr-3 mb-2">
                                        <button type="button" className="font-medium font-14 btn btn-primary custom-btn-primary primary-btn"><img src="images/upload-icon.svg" alt="upload" className="mr-1" /><Trans> Upload</Trans></button>
                                        <input type="file" name="myfile" id="NonCatUploadCustomFile" accept="application/pdf, image/jpeg, image/png, image/jpg" onChange={this.handleAttachment} onClick={this.onInputClick} />
                                    </span>
                                    {this.bindAttachments()}
                                    <div className="err-msg text-danger w-100 "><Trans>{this.state.attachmentErrormsg}</Trans></div>
                                </div>
                            </div>
                            <div className="col-md-12 mb-3">
                                <label className="form-label catalog-label" htmlFor="description"><Trans>Description</Trans><span className="color-manditory">*</span></label>
                                <textarea className="form-control rounded" id="description" placeholder={t("Enter Description")} rows={3} value={this.state.description} maxLength="254" name="description" onChange={this.handleChange} />
                                {this.state.isInvalid && this.state.description.trim() == "" ? <span className="font-12 font-regular color-validation"><Trans>Please enter description</Trans></span> : null}
                            </div>
                            <div className="col-md-12 mb-3 mt-3">
                                <div className="d-flex justify-content-end">
                                    <button className="btn btn-dark-grey font-14 font-medium mr-3 px-4 py-2" onClick={() => this.clearBtnClick()}><Trans>Clear</Trans></button>
                                    <button className="btn btn-custom-primary font-14 font-medium px-4 py-2" onClick={(e) => this.handleSaveBtnClick(e)}><Trans>Save</Trans></button>
                                </div>
                            </div>
                        </div>
                        {/*forms ends here*/}
                        {/*Order Information starts here*/}
                        {this.state.cartItem.length > 0 ?
                            <React.Fragment>
                                <div className="row">
                                    <div className="col-md-12 mt-3">
                                        <span className=" border-top d-flex" />
                                        <h5 className="font-16 font-bold my-4"><Trans>Order information</Trans></h5>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label catalog-label" htmlFor="work-order"><Trans>Work order #</Trans>{CookieService.getLocalStorageValues("Session_CARTWOREQ") != 'N' ? <span className="color-manditory">*</span> : <span></span>}</label>
                                        <div className="input-group">
                                            {/*<input type="text" className="form-control mr-3 rounded" placeholder="Enter work order #" id="work-order" maxLength="9" onKeyDown={this.AnykeyPress} name="WONum" value={this.state.WONum} onChange={this.handleChange} />
                                            {this.state.WONum != undefined && this.state.WONum != null && this.state.WONum != "" && this.state.WONum != " " ?
                                                < span class="search-cancel-header cursor-pointer" style={{ right: "262px" }} onClick={() => this.ClearWO()} > </span> : null
                                            }*/}
                                            <div className="input-group non-cat-search">
                                                {/* 5756 - Work order should be a numeric data and maxof length 9 [4/25/2025] Nachiappan */}
                                                <input type="text" className="form-control border" placeholder={t("Enter work order #")} id="work-order"  maxLength="9" pattern="[0-9]*" inputmode="numeric" aria-label="Text input with dropdown button" onChange={this.handleChange} style={{ "paddingRight": "48px" }} onKeyDown={this.AnykeyPress} name="WONum" value={this.state.WONum} /> {/*4216, 4217, changed the character limit for this field to 256, Divis Kumar R K*/}
                                                <span className={this.state.WONum != undefined && this.state.WONum != null && this.state.WONum != "" && this.state.WONum != " " ? "search-cancel-header cursor-pointer" : "d-none"} style={{ "float": "left" }} onClick={() => this.ClearWO()}></span>
                                                <span className="dropdown-search-icon cursor-pointer" onClick={(e) => this.handleWorkOrderSearch(true)} />
                                            </div>
                                            {this.state.isValidWO != false && this.state.WO_Parts.length != 0 ? <button className="btn-custom-primary border-0 font-14 font-medium px-2 py-2 mt-2 " id="basic-addon2" onClick={e => this.handleWOhistory(e, true)}><img className="mr-1" src="Images/history_icon.svg" alt="History-icon" /><span className="non-cat-labelnone"><Trans> WO# History</Trans></span></button> : null}

                                            {/*<div className="input-group dropdown-search" >
                                                <span className="input-group-text">
                                                    <span className="shopping-search-icon" onClick={(e) => this.handleWorkOrderSearch(true)}  />
                                                </span>
                                            </div>*/}
                                            <span className="errorspan12 text-left my-2" id="StatusMsg"><Trans>{this.state.StatusMsg}</Trans></span>

                                        </div>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label catalog-label" htmlFor="ship-to"><Trans>Ship to</Trans><span className="color-manditory">*</span></label>
                                        <Select
                                            id="WALOLShipTo"
                                            className={CookieService.getLocalStorageValues("Session_CARTWOREQ") != 'N' ? (!this.state.isValidWO && CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") != 'N' ? "DropDown-Font-Size disabled" : "DropDown-Font-Size") : "DropDown-Font-Size"}
                                            value={this.state.defaultShipto}
                                            onChange={(e) => this.handleChangeShipto(e)}
                                            options={this.state.ShipToDDValue}
                                            isDisabled={this.state.EnableShipTo}
                                        />
                                        {!this.state.isCountryMatch ? <div className="mt-2" style={{ "display": "flex", "align-items": "start" }}>
                                            <img class="mr-2 align-top" src="Images/info-icon.png" style={{ "display": "inline" }} />
                                            <label class="confirm-content shipment-font" style={{ "vertical-align": "middle" }}><Trans>The default Ship-To's Country Code does not match the Work Order Store Country Code.</Trans></label>
                                        </div> : null}
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label catalog-label" htmlFor="order-notes" ><Trans>Order notes</Trans></label>
                                        <textarea className="form-control rounded" id="order-notes" placeholder={t("Enter order notes")} name="notes" value={this.state.notes} onChange={this.handleChange} maxLength="254" rows={3} defaultValue={""} />
                                    </div>
                                    <div className="col-md-12 mb-4">
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="checkbox" id="olpriority" defaultValue="option1" name="OLPriority" value={this.state.OLPriority} onChange={this.handleChange} />
                                            <label className="form-check-label catalog-label font-14 font-regular" htmlFor="location"><Trans>Priority </Trans></label>
                                        </div>
                                    </div>
                                    <span className="px-2 errorspan1 mt-3" id="StatusMsg1"><Trans>{this.state.StatusMsg1}</Trans></span>
                                </div>
                                {/*Order Information ends here*/}
                                {/*Item Details starts here*/}

                                <div className="row mt-2">
                                    <div className="col-md-12 mb-4">
                                        <div className="d-grid d-md-flex justify-content-md-between align-items-center grid-resp-style">
                                            <div>
                                                <h5 className="font-16 font-bold"><Trans>Item details</Trans></h5>
                                            </div>

                                            <div className="text-right">
                                                <button className="btn btn-dark-grey  font-14 font-medium mr-3 px-4 py-2" onClick={() => this.cancelOrder()}><Trans>Cancel order</Trans></button>
                                                <button className="btn btn-custom-primary font-14 font-medium px-4 py-2" onClick={() => this.submitOrder()}><Trans>Submit Order</Trans></button>
                                            </div>
                                        </div>
                                    </div>
                                    {this.bindCart()}


                                    <div className="col-md-12 mb-4 mt-5">
                                        <div className="d-flex justify-content-end">
                                            <button className="btn btn-dark-grey  font-14 font-medium mr-3 px-4 py-2" onClick={() => this.cancelOrder()}><Trans>Cancel order</Trans></button>
                                            <button className="btn btn-custom-primary font-14 font-medium px-4 py-2" onClick={() => this.submitOrder()}><Trans>Submit Order</Trans></button>
                                        </div>
                                    </div>
                                    <span className="px-2 errorspan1 mt-3" id="StatusMsg2"><Trans>{this.state.StatusMsg2}</Trans></span>
                                </div>
                            </React.Fragment> : null}
                        {/*Item Details ends here*/}
                    </div>
                </div>
            </div>
            {/*Success Popup Modal Starts here*/}
            <div className="modal fade success-customer" id="submitResponsePopupId" tabIndex={-1} role="dialog" data-backdrop="static" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered custom-success-width" role="document">
                    <div className="modal-content py-2">
                        {/*Success Starts here*/}
                        <div className="modal-body pb-2">
                            <div className="row">
                                <div className="col-12 col-sm-12  col-md-12 col-lg-12 text-center">
                                    <img className="mb-3" src="images/tick.svg" alt="tick" />
                                    <p className="mb-1 font-14 font-regular color-light-black"><Trans>Order submitted for sourcing</Trans></p>
                                </div>
                            </div>
                        </div>
                        {/*Success end here*/}
                        {/*button*/}
                        <div className="modal-footer border-0 d-flex justify-content-center pt-1">
                            <button className="btn btn-custom-primary font-15 font-medium mr-2 mb-2 px-4 py-2" onClick={() => { this.submitResponseOk() }}><Trans>OK</Trans></button>
                        </div>
                        {/*button*/}
                    </div>
                </div>
            </div>
            {/*Success Popup Modal Ends here*/}
            {/*Cancel Popup Modal Starts here*/}
            <div className="modal fade delete-item" tabIndex={-1} role="dialog" id="cancelPopupId" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered custom-delete-width2" role="document">
                    <div className="modal-content py-2">
                        {/*Delete Starts here*/}
                        <div className="modal-body pb-0">
                            <div className="row">
                                <div className="col-12  col-sm-12  col-md-12 col-lg-12 text-center">
                                    <img className="mb-3" src="images/trash.svg" alt="delete" />
                                    <h5 className="mb-2 font-16 font-bold color-light-black"><Trans>Confirm</Trans></h5>
                                    <p className="mb-1 font-13 font-regular color-light-black"><Trans>Are you sure you want to cancel the order?</Trans></p>
                                </div>
                            </div>
                        </div>
                        {/*Delete ends here*/}
                        <div className="modal-footer border-0 d-flex justify-content-center">
                            <button className="btn btn-dark-grey font-14 font-medium mr-2 mb-2 px-4 py-2" data-dismiss="modal"><Trans>No</Trans></button>
                            <button className="btn btn-custom-primary font-14 font-medium mr-2 mb-2 px-4 py-2" onClick={() => this.cancelOrderConfirm()}><Trans>Yes</Trans></button>
                        </div>
                    </div>
                </div>
            </div>
            {/*Cancel Popup Modal Ends here*/}
            {/*Remove Popup Modal Starts here*/}
            <div className="modal fade delete-item" tabIndex={-1} role="dialog" id="removePopup" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered custom-delete-width2" role="document">
                    <div className="modal-content py-2">
                        {/*Delete Starts here*/}
                        <div className="modal-body pb-0">
                            <div className="row">
                                <div className="col-12  col-sm-12  col-md-12 col-lg-12 text-center">
                                    <img className="mb-3" src="images/trash.svg" alt="delete" />
                                    <h5 className="mb-2 font-16 font-bold color-light-black"><Trans>Confirm</Trans></h5>
                                    <p className="mb-1 font-13 font-regular color-light-black"><Trans>Do you want to remove this item?</Trans></p>
                                </div>
                            </div>
                        </div>
                        {/*Delete ends here*/}
                        <div className="modal-footer border-0 d-flex justify-content-center">
                            <button className="btn btn-dark-grey font-14 font-medium mr-2 mb-2 px-4 py-2" data-dismiss="modal"><Trans>No</Trans></button>
                            <button className="btn btn-custom-primary font-14 font-medium mr-2 mb-2 px-4 py-2" onClick={() => this.removeConfirm()}><Trans>Yes</Trans></button>
                        </div>
                    </div>
                </div>
            </div>
            {/*Remove Popup Modal Ends here*/}

            {/*Add Attachment Popup Modal Starts here*/}
            <div className="modal" id="addattachment">
                {this.state.AddAttachPUp ? <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                    <div className="modal-content">
                        {/* Modal Header */}
                        <div className="modal-header">
                            <h4 className="modal-title mt-1"><Trans>Add Attachment</Trans></h4>
                            <button type="button" className="btn close-btn" data-dismiss="modal" onClick={this.clearAttaValid}>
                                X
              </button>
                        </div>
                        {/* Modal body */}
                        <div className="modal-body">
                            <div className="row mb-3">
                                <label className="col-md-5 quick-label"><Trans>Select file to attach</Trans></label>
                                <div className="col-md-7 mb-0">
                                    <div className="text-left">
                                        <label className="file">
                                            <input type="file" title=" " id="WalcartcustomFile" name="filename" aria-label="File browser example" accept="application/pdf, image/jpeg, image/png, image/jpg" onChange={this.handleCartAttachment} onClick={this.onInputClick} />
                                            <span className="file-custom" />
                                        </label>
                                        {this.bindCartAttachments()}
                                        <span className="float-left err-msg text-danger"><Trans>{this.state.attachError}</Trans></span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 mt-2 text-right p-0">
                                <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-4" data-dismiss="modal" onClick={this.clearAttaValid}><Trans>Cancel</Trans></button>
                                <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={(e) => this.updateLineItem("", "", e, "Attachment")} ><Trans>Attach</Trans></button>
                            </div>
                        </div>
                    </div>
                </div> : null}

            </div>
            {/*Add Attachment Popup Modal Ends here*/}

            <div className="modal" id="WO_Parts_Popup" >
                {this.state.isValidWO && this.state.WO_Parts.length > 0 ?
                    <WOPartsComponent closePopup={(e) => this.handleWOhistory(e, false)}  {...this.props} /> : null}
            </div>
        </React.Fragment>
        );
    }
} export default withTranslation()(WALNonCatalogComponent);